import {RelativeTime} from '@primer/react'
import type {ReviewSummary} from '../../../../page-data/payloads/review-summaries'
import {CommentIdentity} from '../shared/CommentIdentity'
import type {CommentAuthorIdentity} from '../util/comment-identity'
import styles from './ReviewTitle.module.css'
import {REVIEW_STATE_DISPLAY} from '../util/review-state-display'

export function ReviewTitle({
  reviewSummary,
  authorIdentity,
  commentsCount,
}: {
  reviewSummary: ReviewSummary
  authorIdentity: CommentAuthorIdentity
  commentsCount: number
}) {
  const {text} = REVIEW_STATE_DISPLAY[reviewSummary.state]

  // TODO - when the onBehalfOfTeams changes ship, we can append it to the author identity here

  return (
    <>
      <CommentIdentity {...authorIdentity} />
      {text}
      <RelativeTime datetime={reviewSummary.submittedAt} className={styles.timestamp} />
      <span className={styles.commentsCount}>
        {commentsCount > 0 && (
          <>
            {' • '}
            {commentsCount} {commentsCount === 1 ? 'comment' : 'comments'}
          </>
        )}
      </span>
    </>
  )
}
